import { RESET_STATE, SET_FORM_INFO, SET_IS_FORM_LOADING, SET_IS_FORM_SENDING } from './actions';

export const initialState = {
	emailVerifyInfo: {},
	isFormSending: false,
	isFormLoading: false,
};

const emailVerifyContainerReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_FORM_INFO:
			return {
				...state,
				emailVerifyInfo: payload,
			};
		case SET_IS_FORM_SENDING:
			return {
				...state,
				isFormSending: payload,
			};
		case SET_IS_FORM_LOADING:
			return {
				...state,
				isFormLoading: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default emailVerifyContainerReducer;
